import { Loader2 } from 'lucide-react';

const PageLoader = () => (
  <div className="flex min-h-screen items-center justify-center bg-background" role="status" aria-live="polite">
    <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden="true" />
    <span className="sr-only">Loading…</span>
  </div>
);

export default PageLoader;
